import { API_SUCCESS, API_FAILED, apiAction, API_ERROR } from '../core/apiCoreRedux';
import store from 'storage';
const LOGIN_API_CALL = 'LOGIN_API_CALL';

// actions
export const login = (data, successCallback = () => { }, failureCallback = () => { }) => ({
  type: LOGIN_API_CALL,
  payload: {
    data,
    successCallback,
    failureCallback
  }
});

// Middleware
export const loginMidlleware =
  ({ dispatch }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case LOGIN_API_CALL:
            const { data: { email, password }, successCallback, failureCallback } = action.payload;
            dispatch(
              apiAction({
                url: ':8989/admin/login',
                actionType: LOGIN_API_CALL,
                data: { email, password },
                meta: { successCallback, failureCallback },
                method: 'POST'
              })
            );
            dispatch(setLoginLoader(true));
            break;

          case `${LOGIN_API_CALL} ${API_SUCCESS}`:
            action.meta.successCallback(action.payload);
            dispatch(setLoginLoader(false));
            break;

          case `${LOGIN_API_CALL} ${API_FAILED}`:
            dispatch(setLoginLoader(false));
            action.meta.failureCallback();

          case `${LOGIN_API_CALL} ${API_ERROR}`:
            dispatch(setLoginLoader(false));
            action.meta.failureCallback();

          default:
          // nothing to be done
        }
      };


// Api check variables
export const setLoginLoader = (data) =>
  ({ type: 'LOGIN_LOADER', payload: data });
export const loginLoaderReducer = (state = false, action = { type: '', payload: false }) => {
  if (action.type === 'LOGIN_LOADER') { return action.payload; } else { return state; }
};
export const getLoginLoader = (state) => state.loginLoader;
